import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SportCompetitionPageFragmentDoc } from '../fragments/SportCompetitionPageV2.fragment';
import { SingleStepTeamFragmentDoc } from '../fragments/SingleStepTeam.fragment';
export type GetSingleStepTeamOrCompetitionQueryVariables = Types.Exact<{
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	bucketSize?: Types.InputMaybe<Types.Scalars['Int']['input']>;
	country: Types.Scalars['Country']['input'];
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	first: Types.Scalars['Int']['input'];
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	language: Types.Scalars['Language']['input'];
	platform: Types.Platform;
	timezoneOffset: Types.Scalars['Int']['input'];
	sortOrder?: Types.SortOrder;
}>;

export type GetSingleStepTeamOrCompetitionQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		urlID: number;
		fullPath: string;
		node:
			| { __typename?: 'Article'; id: string }
			| { __typename?: 'Author'; id: string }
			| { __typename?: 'Bundle'; id: string }
			| { __typename?: 'Device'; id: string }
			| { __typename?: 'Episode'; id: string }
			| { __typename?: 'GenericTitleList'; id: string }
			| { __typename?: 'Genre'; id: string }
			| { __typename?: 'HomePage'; id: string }
			| { __typename?: 'Movie'; id: string }
			| { __typename?: 'MultiStepSportEvent'; id: string }
			| { __typename?: 'Offer'; id: string }
			| { __typename?: 'OfferHistory'; id: string }
			| { __typename?: 'Package'; id: string }
			| { __typename?: 'Page'; id: string }
			| { __typename?: 'Person'; id: string }
			| { __typename?: 'ProfileV2'; id: string }
			| { __typename?: 'Season'; id: string }
			| { __typename?: 'Show'; id: string }
			| { __typename?: 'SingleStepSportEvent'; id: string }
			| {
					__typename?: 'SportCompetitionV2';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					sport: Types.SportType;
					content: {
						__typename?: 'SportCompetitionContentV2';
						name: string;
						fullPath: string;
						iconUrl?: string | null;
					};
					activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
					sportEventsV2: {
						__typename?: 'SportEventsConnectionV2';
						pageInfo: {
							__typename?: 'PageInfo';
							startCursor: string;
							endCursor: string;
							hasPreviousPage: boolean;
							hasNextPage: boolean;
						};
						edges?: Array<{
							__typename?: 'SportEventsEdgeV2';
							node:
								| {
										__typename?: 'MultiStepSportEvent';
										id: string;
										objectId: number;
										sport: Types.SportType;
										offerCount: number;
										competition?: {
											__typename?: 'SportCompetitionV2';
											id: string;
											objectId: number;
											activeSeason?: {
												__typename?: 'SportSeason';
												name: string;
												seasonID: number;
											} | null;
										} | null;
										content: {
											__typename?: 'MultiStepSportEventContent';
											startAt: any;
											endAt?: any | null;
											status: Types.SportEventStatus;
											fullPath?: string | null;
											venue?: { __typename?: 'SportVenue'; name: string; venueID: number } | null;
											competitionStage: {
												__typename?: 'SportCompetitionStageV2';
												name: Types.SportCompetitionStageName;
												number?: number | null;
											};
										};
										parent?: {
											__typename?: 'MultiStepSportEvent';
											id: string;
											content: {
												__typename?: 'MultiStepSportEventContent';
												name: string;
												fullPath?: string | null;
												startAt: any;
												status: Types.SportEventStatus;
											};
										} | null;
										watchNowOffer?: {
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
												iconWide: string;
											};
										} | null;
										offers: Array<{
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
											};
										}>;
								  }
								| {
										__typename?: 'SingleStepSportEvent';
										id: string;
										objectId: number;
										sport: Types.SportType;
										offerCount: number;
										competition?: {
											__typename?: 'SportCompetitionV2';
											id: string;
											objectId: number;
											activeSeason?: {
												__typename?: 'SportSeason';
												name: string;
												seasonID: number;
											} | null;
										} | null;
										content: {
											__typename?: 'SingleStepSportEventContent';
											startAt: any;
											endAt?: any | null;
											status: Types.SportEventStatus;
											fullPath?: string | null;
											venue?: { __typename?: 'SportVenue'; name: string; venueID: number } | null;
											competitionStage: {
												__typename?: 'SportCompetitionStageV2';
												name: Types.SportCompetitionStageName;
												number?: number | null;
											};
										};
										competitors: {
											__typename?: 'SingleStepSportCompetitorsV2';
											homeTeam: {
												__typename?: 'SingleStepSportCompetitorV2';
												score?: number | null;
												winner: boolean;
												competitors: Array<{
													__typename?: 'SportCompetitorV2';
													id: string;
													objectId: number;
													content: {
														__typename?: 'SportCompetitorContentV2';
														name: string;
														iconUrl?: string | null;
														fullPath?: string | null;
													};
												}>;
											};
											awayTeam: {
												__typename?: 'SingleStepSportCompetitorV2';
												score?: number | null;
												winner: boolean;
												competitors: Array<{
													__typename?: 'SportCompetitorV2';
													id: string;
													objectId: number;
													content: {
														__typename?: 'SportCompetitorContentV2';
														name: string;
														iconUrl?: string | null;
														fullPath?: string | null;
													};
												}>;
											};
										};
										watchNowOffer?: {
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
												iconWide: string;
											};
										} | null;
										offers: Array<{
											__typename?: 'SportOffer';
											monetizationType: Types.MonetizationType;
											presentationType: Types.PresentationType;
											audioLanguage?: string | null;
											standardWebURL?: string | null;
											sportObjectType: Types.SportObjectType;
											package: {
												__typename?: 'Package';
												id: string;
												packageId: number;
												technicalName: string;
												clearName: string;
												shortName: string;
												monetizationTypes: Array<Types.MonetizationType>;
											};
										}>;
								  };
						}> | null;
					};
			  }
			| {
					__typename?: 'SportCompetitorV2';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'SportCompetitorContentV2'; name: string; iconUrl?: string | null };
					sportEventBucketsV2: {
						__typename?: 'SportEventBucketsConnectionV2';
						edges?: Array<{
							__typename?: 'SportEventBucketsEdgeV2';
							key: {
								__typename?: 'SportEventAggregationKeyV2';
								competition?: {
									__typename?: 'SportCompetitionV2';
									id: string;
									content: {
										__typename?: 'SportCompetitionContentV2';
										name: string;
										fullPath: string;
										iconUrl?: string | null;
									};
								} | null;
							};
							node: {
								__typename?: 'SportEventsConnectionV2';
								edges?: Array<{
									__typename?: 'SportEventsEdgeV2';
									node:
										| { __typename?: 'MultiStepSportEvent' }
										| {
												__typename: 'SingleStepSportEvent';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												sport: Types.SportType;
												offerCount: number;
												content: {
													__typename?: 'SingleStepSportEventContent';
													name: string;
													status: Types.SportEventStatus;
													startAt: any;
													endAt?: any | null;
													fullPath?: string | null;
													venue?: {
														__typename?: 'SportVenue';
														venueID: number;
														name: string;
													} | null;
													competitionStage: {
														__typename?: 'SportCompetitionStageV2';
														name: Types.SportCompetitionStageName;
														number?: number | null;
													};
													pastEvents: Array<{
														__typename?: 'SingleStepSportEvent';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														sport: Types.SportType;
														competition?: {
															__typename?: 'SportCompetitionV2';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															sport: Types.SportType;
															content: {
																__typename?: 'SportCompetitionContentV2';
																fullPath: string;
																name: string;
															};
														} | null;
														competitors: {
															__typename?: 'SingleStepSportCompetitorsV2';
															homeTeam: {
																__typename?: 'SingleStepSportCompetitorV2';
																score?: number | null;
																competitors: Array<{
																	__typename?: 'SportCompetitorV2';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																	sport: Types.SportType;
																	content: {
																		__typename?: 'SportCompetitorContentV2';
																		firstName: string;
																		fullPath?: string | null;
																		lastName: string;
																		name: string;
																		iconUrl?: string | null;
																	};
																}>;
															};
															awayTeam: {
																__typename?: 'SingleStepSportCompetitorV2';
																score?: number | null;
																competitors: Array<{
																	__typename?: 'SportCompetitorV2';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																	sport: Types.SportType;
																	content: {
																		__typename?: 'SportCompetitorContentV2';
																		firstName: string;
																		fullPath?: string | null;
																		lastName: string;
																		name: string;
																		iconUrl?: string | null;
																	};
																}>;
															};
														};
														content: {
															__typename?: 'SingleStepSportEventContent';
															name: string;
															startAt: any;
															status: Types.SportEventStatus;
															season?: {
																__typename?: 'SportSeason';
																name: string;
																seasonID: number;
															} | null;
														};
													}>;
												};
												mysportlistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												competition?: {
													__typename?: 'SportCompetitionV2';
													id: string;
													objectId: number;
													sport: Types.SportType;
													activeSeason?: {
														__typename?: 'SportSeason';
														name: string;
														seasonID: number;
													} | null;
													content: {
														__typename?: 'SportCompetitionContentV2';
														name: string;
														fullPath: string;
														iconUrl?: string | null;
													};
												} | null;
												competitors: {
													__typename?: 'SingleStepSportCompetitorsV2';
													homeTeam: {
														__typename?: 'SingleStepSportCompetitorV2';
														score?: number | null;
														winner: boolean;
														competitors: Array<{
															__typename?: 'SportCompetitorV2';
															id: string;
															objectId: number;
															content: {
																__typename?: 'SportCompetitorContentV2';
																name: string;
																iconUrl?: string | null;
																fullPath?: string | null;
															};
														}>;
													};
													awayTeam: {
														__typename?: 'SingleStepSportCompetitorV2';
														score?: number | null;
														winner: boolean;
														competitors: Array<{
															__typename?: 'SportCompetitorV2';
															id: string;
															objectId: number;
															content: {
																__typename?: 'SportCompetitorContentV2';
																name: string;
																iconUrl?: string | null;
																fullPath?: string | null;
															};
														}>;
													};
												};
												watchNowOffer?: {
													__typename?: 'SportOffer';
													monetizationType: Types.MonetizationType;
													presentationType: Types.PresentationType;
													audioLanguage?: string | null;
													standardWebURL?: string | null;
													sportObjectType: Types.SportObjectType;
													package: {
														__typename?: 'Package';
														id: string;
														packageId: number;
														technicalName: string;
														clearName: string;
														shortName: string;
														monetizationTypes: Array<Types.MonetizationType>;
														iconWide: string;
													};
												} | null;
												offers: Array<{
													__typename?: 'SportOffer';
													monetizationType: Types.MonetizationType;
													presentationType: Types.PresentationType;
													audioLanguage?: string | null;
													standardWebURL?: string | null;
													sportObjectType: Types.SportObjectType;
													package: {
														__typename?: 'Package';
														id: string;
														packageId: number;
														technicalName: string;
														clearName: string;
														shortName: string;
														monetizationTypes: Array<Types.MonetizationType>;
													};
												}>;
										  };
								}> | null;
							};
						}> | null;
					};
			  }
			| { __typename?: 'SportMatch'; id: string }
			| { __typename?: 'Url'; id: string };
	};
};

export const GetSingleStepTeamOrCompetitionDocument = gql`
	query GetSingleStepTeamOrCompetition(
		$after: String
		$bucketSize: Int
		$country: Country!
		$filter: SportEventFilter
		$first: Int!
		$fullPath: String!
		$site: String
		$language: Language!
		$platform: Platform!
		$timezoneOffset: Int!
		$sortOrder: SortOrder! = ASC
	) {
		urlV2(fullPath: $fullPath, site: $site) {
			id
			urlID
			fullPath
			node {
				id
				... on SportCompetitionV2 {
					...SportCompetitionPage
				}
				... on SportCompetitorV2 {
					...SingleStepTeam
				}
			}
		}
	}
	${SportCompetitionPageFragmentDoc}
	${SingleStepTeamFragmentDoc}
`;
